<template>
  <div class="main-wrapper login-body">
    <!-- Header -->
    <header class="log-header">
      <router-link to="/">
        <img class="img-fluid logo-dark" src="@/assets/img/logo.ad0b8567.png" alt="الشعار" />
      </router-link>
    </header>
    <!-- /Header -->

    <div class="login-wrapper">
      <div class="loginbox">
        <div class="login-auth">
          <div class="login-auth-wrap">
            <div class="sign-group">
              <router-link to="/" class="btn sign-up">
                <span>
                  <i class="fe feather-corner-down-left" aria-hidden="true"></i>
                </span>
                العودة للصفحة الرئيسية
              </router-link>
            </div>
            <h1>إنشاء حساب</h1>
            <p class="account-subtitle">سيتم إرسال رمز التحقق إلى هاتفك.</p>

            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <!-- رقم الهاتف -->
              <div class="input-block">
                <label class="form-label">
                  رقم الهاتف <span class="text-danger">*</span>
                </label>
                <Field
                  name="phone"
                  type="text"
                  class="form-control"
                  placeholder="أدخل رقم الهاتف"
                  :class="{ 'is-invalid': errors.phone }"
                />
                <div class="invalid-feedback">{{ errors.phone }}</div>
              </div>

              <!-- كود الدولة -->
              <div class="input-block mt-3">
                <label class="form-label">
                  كود الدولة <span class="text-danger">*</span>
                </label>
                <Field
                  name="country_code"
                  type="text"
                  class="form-control"
                  placeholder="+20"
                  :class="{ 'is-invalid': errors.country_code }"
                />
                <div class="invalid-feedback">{{ errors.country_code }}</div>
              </div>

              <!-- تاريخ الميلاد -->
              <div class="input-block mt-3">
                <label class="form-label">
                  تاريخ الميلاد
                </label>
                <Field
                  name="birthdate"
                  type="date"
                  class="form-control"
                  :class="{ 'is-invalid': errors.birthdate }"
                />
                <div class="invalid-feedback">{{ errors.birthdate }}</div>
              </div>

              <!-- كلمة المرور -->
              <!-- <div class="input-block mt-3">
                <label class="form-label">
                  كلمة المرور <span class="text-danger">*</span>
                </label>
                <div class="pass-group">
                  <Field
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control pass-input mt-2"
                    placeholder="كلمة المرور"
                    :class="{ 'is-invalid': errors.password }"
                  />
                  <span @click="toggleShow" class="toggle-password">
                    <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                </div>
              </div> -->

              <b-button class="primary btn-block mt-3" type="submit" :disabled="auth.isLoading">
                {{ auth.isLoading ? 'جارٍ التحميل...' : 'إنشاء الحساب' }}
              </b-button>
            </Form>

            <div class="text-center dont-have mt-3">
              لديك حساب بالفعل؟
              <router-link to="/authentication/login">تسجيل الدخول</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <auth-footer></auth-footer>
    <!-- /Footer -->
  </div>
</template>

<script>
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router"; // 

export default {
  components: { Form, Field },
  setup() {
    const auth = useAuthStore();
    const showPassword = ref(false);
    const router = useRouter(); 
    const toggleShow = () => {
      showPassword.value = !showPassword.value;
    };

    const schema = Yup.object().shape({
      phone: Yup.string().required("رقم الهاتف مطلوب"),
      country_code: Yup.string().required("كود الدولة مطلوب"),
      birthdate: Yup.string().nullable(),
      // password: Yup.string().min(6, "كلمة المرور يجب ألا تقل عن 6 أحرف").required("كلمة المرور مطلوبة"),
    });

    const onSubmit = async (values) => {
    const success =  await auth.register(values);
    if (success) {
      router.push("/authentication/CompleteProfile");
    }
    };

    return { showPassword, toggleShow, schema, onSubmit, auth };
  },
};
</script>

<style scoped>
.logo-dark {
  width: 150px;
  height: auto;
}
</style>
